export default "__VITE_ASSET__DMfE8Bny__"